{{#each policyHandle.klass.handlesWithSetters}}
{{ ../policyHandle.fullName }}.{{ setterName }}({{ identifier }});
{{/each}}
{{ item.shortName }}.add_policy({{ policyHandle.fullName }});
